import { useAuth } from '~/layers/auth/composables/useAuth'

export default defineNuxtPlugin(async () => {
  if (process.client) {
    try {
      localStorage.removeItem('auth.user')
    } catch (e) {
    }

    // Clear session storage on tab close
    window.addEventListener('beforeunload', () => {
      try {
        sessionStorage.clear()
      } catch (e) {
        // Ignore errors
      }
    })
  }

  const { fetchCurrentUser } = useAuth()
  const hasSession = useCookie("XSRF-TOKEN", {
    maxAge: undefined,
    expires: undefined
  })

  if (hasSession.value && process.client) {
    try {
      await fetchCurrentUser()
    } catch (error) {
      console.error('Failed to initialize auth from session:', error)
    }
  }
}) 